import React from 'react';
import './MatchReplayUnavailableModal.css';
import PageButton from '../../elements/PageButton/PageButton';

const PAGE_ID = 'MatchReplayUnavailableModal';

// isAccessDenied — запись есть, но сервер отказал этому зрителю: запись
// сетевого матча смотрят его участники (см. resolveMatchRecordingAccess)
function MatchReplayUnavailableModal({onHide, isAccessDenied = false}) {
  return (
    <div className="match-replay-unavailable-overlay" onClick={onHide} role="dialog" aria-modal="true">
      <div className="match-replay-unavailable-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="match-replay-unavailable-title">Запись недоступна</h2>
        <p className="match-replay-unavailable-text">
          {isAccessDenied
            ? 'Запись матча могут смотреть только его участники. Если вы играли в этом матче, обновите страницу и войдите заново.'
            : 'Для этого матча не найдено записи.'}
        </p>
        <div className="main-menu-buttons match-replay-unavailable-buttons">
          <PageButton onClick={onHide} pageId={PAGE_ID} buttonId="hide">
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default MatchReplayUnavailableModal;
